import { AuthClient } from "@/utils/client";

export const getMostLikedMinerals = () => {
  return AuthClient().get(`/users/badge-specimen`);
};

export const getMostLikedMineralById = (mineralId: string) => {
  return AuthClient().get(`/common/comment/${mineralId}`);
};
export const getMostdMinerals = () => {
  return AuthClient().get(`/users/badge-mineralCount`);
};

export const getMostLikedCatalog = () => {
  return AuthClient().get(`/users/badge-catalog`);
};

export const getUserBadgeById = (userId: string) => {
  return AuthClient().get(`/users/badge-user/${userId}`);
};
